<template>
  <div class="content-header-title">{{title}}</div>
</template>

<script>
export default {
  name: "DyContentHeader",
  props: {
    title: '商户管理'
  }
}
</script>

<style lang="scss" scoped>
.content-header-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 44px;
  margin: 10px 0 16px 4px;
}
</style>
